export default __webpack_public_path__ + "pi1-1QAAT/components/SocialProof/images/income-general-58c0101702eebaeca112f9390f52112e.svg";